import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes, Navigate } from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";

import store from "./appRedux/store/configureStore";
import App from "./containers/App/index";
import Loader from "./components/loader";
import Login from "./containers/Login";
import Logout from "./containers/Logout";
import SetPassword from "./containers/SetPassword";
import ResetPassword from "./containers/ResetPassword";
import asyncComponent from "./util/asyncComponent";
import MainApp from "./containers/App/MainApp";

const RestrictedRoute = ({ children }) => {
  const authUser = true; // Replace with your actual auth check

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const NotFound = () => {
  const NotFoundComponent = asyncComponent(
    () => import("./containers/error-pages/404"),
  );
  return <NotFoundComponent />;
};

const NextApp = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="login" element={<Login />} />
          <Route path="logout" element={<Logout />} />
          <Route path="set-password/:token" element={<SetPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="error-404" element={<NotFound />} />
          <Route
            path="*"
            element={
              <RestrictedRoute>
                <MainApp />
              </RestrictedRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
    <Loader />
  </Provider>
);

export default NextApp;
